/* eslint-disable react/prefer-stateless-function */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import FilterLayout from './FilterLayout';
import RadioFilter from './RadioFilter';
import CheckboxFilter from './CheckboxFilter';
import GroupedCheckboxFilter from './GroupedCheckboxFilter';
import CollapsibleCheckboxFilter from './CollapsibleCheckboxFilter';

class CommonFilters extends Component {
    relationshipFilter(relationshipFilter) {
        if (!relationshipFilter) return null;
        return (
            <FilterLayout title={relationshipFilter.title}>
                <CheckboxFilter
                    filter={relationshipFilter}
                    options={relationshipFilter.options}
                    onChange={this.props.onChange}
                />
            </FilterLayout>
        );
    }

    lastActivityFilter(lastActivityFilter) {
        if (!lastActivityFilter) return null;
        return (
            <FilterLayout title={lastActivityFilter.title}>
                <RadioFilter
                    filter={lastActivityFilter}
                    options={lastActivityFilter.options}
                    onChange={this.props.onChange}
                />
            </FilterLayout>
        );
    }

    contactsFilter(contactsFilter) {
        if (!contactsFilter) return null;
        return (
            <FilterLayout title={contactsFilter.title}>
                <RadioFilter
                    filter={contactsFilter}
                    options={contactsFilter.options}
                    onChange={this.props.onChange}
                />
            </FilterLayout>
        );
    }

    certificationsFilter(certificationsFilter) {
        if (!certificationsFilter) return null;
        return (
            <FilterLayout title={certificationsFilter.title}>
                <CheckboxFilter
                    filter={certificationsFilter}
                    options={certificationsFilter.options}
                    onChange={this.props.onChange}
                />
            </FilterLayout>
        );
    }

    render() {
        const { filterStore } = this.props;
        const categoryFilter = filterStore.getFilterByName('categories');
        const industryFilter = filterStore.getFilterByName('industries');
        const relationshipFilter = filterStore.getFilterByName('relationship');
        const lastActivityFilter = filterStore.getFilterByName('lastActive');
        const levelFilter = filterStore.getFilterByName('designerLevels');
        const languagesFilter = filterStore.getFilterByName('languages');
        const contactsFilter = filterStore.getFilterByName('contacts');
        const certificationsFilter = filterStore.getFilterByName('certifications');

        return (
            <div>
                <FilterLayout title={categoryFilter.title}>
                    <GroupedCheckboxFilter filter={categoryFilter} onChange={this.props.onChange} />
                </FilterLayout>
                <FilterLayout title={industryFilter.title}>
                    <CollapsibleCheckboxFilter
                        filter={industryFilter}
                        onChange={this.props.onChange}
                    />
                </FilterLayout>
                {this.relationshipFilter(relationshipFilter)}
                {this.lastActivityFilter(lastActivityFilter)}
                <FilterLayout title={levelFilter.title}>
                    <CheckboxFilter
                        filter={levelFilter}
                        options={levelFilter.options}
                        onChange={this.props.onChange}
                    />
                </FilterLayout>
                <FilterLayout title={languagesFilter.title}>
                    <CheckboxFilter
                        filter={languagesFilter}
                        options={languagesFilter.options}
                        onChange={this.props.onChange}
                    />
                </FilterLayout>
                {this.contactsFilter(contactsFilter)}
                {this.certificationsFilter(certificationsFilter)}
            </div>
        );
    }
}

CommonFilters.propTypes = {
    filterStore: PropTypes.shape({
        getFilterByName: PropTypes.func.isRequired,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default inject('filterStore')(observer(CommonFilters));



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/CommonFilters.jsx